export function itemsToMap(items = []) {
  const out = {};
  for (const item of items || []) {
    const sku = String(item?.sku || "").trim();
    if (!sku) continue;
    const qty = Math.max(0, Number(item?.quantity || 0));
    out[sku] = (out[sku] || 0) + qty;
  }
  return out;
}

export function scoreRecipeSimilarity(targetItems = [], candidateItems = []) {
  const a = itemsToMap(targetItems);
  const b = itemsToMap(candidateItems);
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  const all = [...new Set([...keysA, ...keysB])];
  if (!all.length) return { score: 0, percent: 0, level: "none", details: {} };

  let minQty = 0;
  let maxQty = 0;
  for (const sku of all) {
    minQty += Math.min(a[sku] || 0, b[sku] || 0);
    maxQty += Math.max(a[sku] || 0, b[sku] || 0);
  }
  const qtyOverlap = maxQty ? minQty / maxQty : 0;

  const setA = new Set(keysA);
  const setB = new Set(keysB);
  const intersection = [...setA].filter((sku) => setB.has(sku)).length;
  const union = new Set([...keysA, ...keysB]).size;
  const skuOverlap = union ? intersection / union : 0;

  const totalA = Object.values(a).reduce((s, v) => s + v, 0);
  const totalB = Object.values(b).reduce((s, v) => s + v, 0);
  const totalCloseness = Math.max(totalA, totalB) ? Math.min(totalA, totalB) / Math.max(totalA, totalB) : 0;

  const raw = qtyOverlap * 0.6 + skuOverlap * 0.25 + totalCloseness * 0.15;
  const score = Math.max(0, Math.min(1, raw));
  const percent = Math.round(score * 1000) / 10;
  let level = "low";
  if (score >= 0.995) level = "identical";
  else if (score >= 0.8) level = "very_similar";
  else if (score >= 0.6) level = "similar";
  else if (score >= 0.35) level = "related";

  return {
    score,
    percent,
    level,
    details: {
      qty_overlap: Math.round(qtyOverlap * 1000) / 10,
      sku_overlap: Math.round(skuOverlap * 1000) / 10,
      total_closeness: Math.round(totalCloseness * 1000) / 10,
      common_skus: intersection,
      target_skus: keysA.length,
      candidate_skus: keysB.length,
      target_qty: totalA,
      candidate_qty: totalB,
    },
  };
}

export function rankSimilarRecipes(targetRecipe, recipes = [], limit = 5) {
  if (!targetRecipe) return [];
  return (recipes || [])
    .filter((r) => r && r.id !== targetRecipe.id)
    .filter((r) => !targetRecipe.pallet_type_id || !r.pallet_type_id || r.pallet_type_id === targetRecipe.pallet_type_id)
    .map((recipe) => ({
      recipe,
      ...scoreRecipeSimilarity(targetRecipe.items || [], recipe.items || []),
    }))
    .filter((x) => x.score > 0)
    .sort((a, b) => b.score - a.score || String(b.recipe.created_at || "").localeCompare(String(a.recipe.created_at || "")))
    .slice(0, Math.max(1, limit));
}
